import {SelectInterface} from '../components/register-section/types/vuon-concert-2025.types';
import {ImageRaw} from '../../../components/image-raw';
import LinearText from '../components/linear-text/linear-text';

export enum ParticipantType {
    NursingFather = 'NURSING_FATHER',
    NursingMother = 'NURSING_MOTHER',
    PregnantFather = 'PREGNANT_FATHER',
    PregnantMother = 'PREGNANT_MOTHER',
    Other = 'OTHER',
    Fandom = 'FANDOM',
}

export const ParticipantTypes: SelectInterface[] = [
    {value: ParticipantType.NursingMother, label: 'Mẹ bỉm sữa'},
    {value: ParticipantType.NursingFather, label: 'Bố bỉm sữa'},
    {value: ParticipantType.Fandom, label: 'Fandom'},
    {value: ParticipantType.Other, label: 'Khác'},
] as const;

export const TicketExchangeStores: SelectInterface[] = [
    {
        value: '30380',
        label: 'Cửa hàng KidsPlaza - C2-1 Nguyễn Cơ Thạch, KĐT Mỹ Đình I, P. Cầu Diễn, Quận Nam Từ Liêm, Hà Nội',
    },
    {
        value: '30230',
        label: 'Cửa hàng KidsPlaza - HH2 Bắc Hà, P. Tố Hữu, Trung Văn, Nam Từ Liêm, Hà Nội',
    },
    {
        value: '30110',
        label: 'Cửa hàng KidsPlaza - Số 4 - 6 Nguyễn Hữu Thọ, Bắc Linh Đàm, P. Đại Kim, Quận Hoàng Mai, Hà Nội',
    },
    {
        value: '30760',
        label: 'Cửa hàng KidsPlaza - Số 301 Tô Hiệu, P. Dịch Vọng, Quận Cầu Giấy, Hà Nội',
    },
    {
        value: '30100',
        label: 'Cửa hàng KidsPlaza - Số 9 Tân Mai, P Tân Mai, Quận Hoàng Mai, Hà Nội',
    },
    {
        value: '30400',
        label: 'Cửa hàng KidsPlaza - Số 410 Quang Trung, P. La Khê, Quận Hà Đông, Hà Nội',
    },
    {
        value: '30240',
        label: 'Cửa hàng KidsPlaza - Số 22 Nguyễn Xiển, P. Thanh Xuân Nam, Quận Thanh Xuân, Hà Nội',
    },
    {
        value: '30330',
        label: 'Cửa hàng KidsPlaza - HH4B Linh Đàm, P. Linh Đường, Hoàng Liệt, Hoàng Mai, Hà Nội',
    },
    {
        value: '30220',
        label: 'Cửa hàng KidsPlaza - 77B Xuân La, Tây Hồ, Hà Nội',
    },
    {
        value: '99999',
        label: 'KidsPlaza - Dãy CT9-6 Khu nhà ở Himlam Vạn Phúc, Phường Vạn Phúc, Quận Hà Đông, HN',
    },
] as const;

export const initialCustomer = {
    telephone: '',
    fullName: '',
    email: '',
    birthday: '',
    participantType: {
        value: '',
        label: '',
    },
    ticketExchangeStore: {
        value: '',
        label: '',
    },
    // Thêm initial values cho region, ward và street
    region: {
        id: 0,
        value: '',
        label: '',
    },
    ward: {
        value: 0,
        label: '',
    },
    street: '',
} as const;

export const TERMS =
    `Tôi cam kết đã đọc và hiểu rõ mọi thông tin về “Vươn concert” và yêu cầu của BTC. Mọi thông tin tôi cung cấp tại form này đều là đúng sự thật. Trong trường hợp thông tin cung cấp không đúng sự thật, BTC có quyền huỷ đăng ký vé tham gia “Vươn concert” và chịu mọi trách nhiệm có liên quan` as const;
export const MEDIA_CONSENT =
    `Quý khách xác nhận cho phép BTC và các đối tác liên quan được ghi hình, chụp ảnh và sử dụng hình ảnh cá nhân trong các hoạt động truyền thông, quảng bá sự kiện trên các nền tảng số và ấn phẩm truyền thông không giới hạn thời gian và không cần thông báo thêm. Mọi nội dung sử dụng đều tuân thủ đúng quy định pháp luật hiện hành.` as const;

export const GUIDELINE_SECTION = [
    {
        title: 'SƠ ĐỒ KHU VỰC SÂN KHẤU',
        titleClassName: 'p-2 text-[24px] font-extrabold text-white',
        content: (
            <div className="w-full h-full !bg-[#FFF9D7] rounded-b-[16px]">
                <ImageRaw
                    className="w-full h-full object-contain rounded-b-[16px]"
                    src="https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/optimized/v2/stage_area_map.webp"
                    alt="Sơ đồ khu vực concert"
                />
            </div>
        ),
        contentClassName: 'px-[100px]',
        className: 'max-w-[906px]',
    },
    {
        title: 'CHÍNH SÁCH AN TOÀN VÉ KIDSPLAZA',
        titleClassName: 'p-2 text-[24px] font-extrabold text-white',
        content: (
            <div className="p-3 text-black text-bold text-[12px]">
                <div className="rounded-md">
                    <LinearText className="font-extrabold font-montserrat text-[16px]">
                        1. KÊNH PHÁT HÀNH VÉ CHÍNH THỨC
                    </LinearText>
                    <ul className="list-[upper-alpha] pl-6 font-bold font-montserrat text-[12px]">
                        <li>
                            Vé online concert chỉ được phát hành bởi KidsPlaza thông qua link (
                            <a href="#register-section" className="text-black underline">
                                Đăng ký vé
                            </a>
                            ) và cập nhật tại fanpage{' '}
                            <a
                                href="https://www.facebook.com/kidsplaza.com.vn"
                                className="text-black underline"
                                target="_blank"
                                rel="noreferrer">
                                KidsPlaza.vn
                            </a>{' '}
                            (có tích xanh).
                        </li>
                        <li>
                            BTC gửi vé điện tử trực tiếp qua email/Zalo OA cho khách hàng đăng ký thành công và đủ điều
                            kiện tham gia qua số điện thoại khách đăng ký.
                        </li>
                        <li>
                            KidsPlaza khuyến nghị Quý khách hàng không mua vé thông qua các kênh không chính thống. BTC
                            KHÔNG công nhận và chịu trách nhiệm với vé được cung cấp từ những nguồn khác.
                        </li>
                    </ul>
                </div>
                <div className="rounded-md">
                    <LinearText className="font-bold font-montserrat text-[16px]">
                        2. ĐỊNH DANH VÉ - NGĂN CHUYỂN NHƯỢNG, LỪA ĐẢO
                    </LinearText>
                    <ul className="list-[upper-alpha] pl-6 space-y-1 font-bold font-montserrat text-[12px]">
                        <li>Mỗi vé điện tử gắn với 01 mã QR và 01 số điện thoại.</li>
                        <li>
                            Quý khách hàng sau khi nhận được mã vé thành công tiến hành đổi vé cứng tại hệ thống cửa
                            hàng offline của KidsPlaza như đã đăng ký.
                        </li>
                        <li>
                            Thời gian và ngày đổi vé cứng sẽ được KidsPlaza gửi tới khách hàng đủ điều kiện qua Email và
                            Zalo OA đã đăng ký vé concert.
                        </li>
                        <li>Quý khách hàng khi đến check-in tại sự kiện cần xuất trình vé cứng đã được quy đổi.</li>
                        <li>
                            Mỗi khách hàng chỉ được đăng ký 01 vé duy nhất. Mỗi vé chỉ sử dụng vào cửa duy nhất 01 lần.
                        </li>
                        <li>
                            Mọi trường hợp cần hỗ trợ vé và thông tin vé concert vui lòng liên hệ hotline KidsPlaza theo
                            số 18006608 - Nhánh số 3.
                        </li>
                    </ul>
                </div>
            </div>
        ),
        contentClassName: ' ',
        className: '',
    },
    {
        title: 'ĐIỀU KHOẢN CHUNG',
        titleClassName: 'p-2 text-[24px] font-extrabold text-white',
        content: (
            <div className="text-black text-[12px] p-3">
                <div className="rounded-md">
                    <LinearText className="font-bold font-montserrat text-[16px] mb-2">1. QUY ĐỊNH CHUNG</LinearText>
                    <ul className="list-[upper-alpha] pl-6 space-y-1 font-bold font-montserrat text-[12px]">
                        <li>
                            Để đảm bảo an ninh cho sự kiện, BTC có quyền kiểm tra tư trang của tất cả người tham dự khi
                            qua cổng an ninh.
                        </li>
                        <li>
                            BTC không chịu trách nhiệm đối với các tài sản bị mất, bị đánh cắp hoặc bị hư hỏng. Khuyến
                            cáo bạn không nên mang theo những đồ có giá trị.
                        </li>
                        <li>
                            BTC có quyền từ chối hoặc mời ra khỏi khu vực biểu diễn bất cứ cá nhân nào vi phạm quy định.
                        </li>
                        <li>BTC giữ quyền quyết định cuối cùng trong mọi trường hợp.</li>
                    </ul>
                </div>
                <div className="rounded-md">
                    <LinearText className="font-bold font-montserrat text-[16px] mb-2">
                        2. QUY ĐỊNH VỀ ĐỐI TƯỢNG THAM DỰ
                    </LinearText>
                    <ul className="list-[upper-alpha] pl-6 space-y-1 font-bold font-montserrat text-[12px]">
                        <li>Chương trình âm nhạc "Vươn concert" chỉ dành cho Quý khách hàng từ 18 tuổi trở lên.</li>
                        <li>
                            Chương trình không phù hợp cho Quý khách hàng là phụ nữ mang thai và trẻ em dưới 18 tuổi.
                        </li>
                    </ul>
                </div>
            </div>
        ),
        contentClassName: ' ',
        className: '',
    },
    {
        title: 'QUY ĐỊNH CHECK IN',
        titleClassName: 'p-2 text-[24px] font-extrabold text-white',
        content: (
            <div className="text-black text-[12px] p-3">
                <div className="rounded-md">
                    <LinearText className="font-bold font-montserrat text-[16px] mb-2">1. VÉ CỨNG</LinearText>
                    <ul className="list-[upper-alpha] pl-6 space-y-1 font-bold font-montserrat text-[12px]">
                        <li>
                            Vé check in tham gia sự kiện là bản vé in cứng (bắt buộc còn nguyên vẹn và đúng tiêu chuẩn
                            theo quy định)
                        </li>
                        <li>
                            Mỗi vé chỉ có dành 01 lượt vào cổng. Quý khách hàng tự bảo quản vé cứng. BTC không chịu
                            trách nhiệm trong trường hợp vé bị lộ thông tin check in/ mất/ hỏng.
                        </li>
                    </ul>
                </div>
                <div className="rounded-md">
                    <LinearText className="font-bold font-montserrat text-[16px] mb-2">2. VÒNG TAY CHECK IN</LinearText>
                    <ul className="list-[upper-alpha] pl-6 space-y-1 font-bold font-montserrat text-[12px]">
                        <li>
                            Sau khi xuất trình vé cứng, mỗi khách hàng được đeo 01 vòng tay sử dụng để ra vào nhạc hội
                            trong thời gian diễn ra concert.
                        </li>
                        <li>Mỗi vé cứng chỉ quy đổi được duy nhất 01 vòng tay áp dụng cho 01 khách hàng.</li>
                        <li>
                            Vòng tay sẽ chỉ được phát duy nhất 01 lần khi khách thực hiện check in. BTC không chịu trách
                            nhiệm và có quyền từ chối cho khán giả vào trong khu khán đài biểu diễn trong trường hợp mất
                            vòng tay.
                        </li>
                    </ul>
                </div>
                <div className="rounded-md">
                    <LinearText className="font-bold font-montserrat text-[16px] mb-2">3. LIGHTSTICK</LinearText>
                    <ul className="list-[upper-alpha] pl-6 space-y-1 font-bold font-montserrat text-[12px]">
                        <li>
                            Tại ngày tham gia sự kiện, Quý khách hàng giữ vé cứng và đổi lấy lightstick miễn phí tại
                            quầy check in.
                        </li>
                        <li>BTC thu lại sau khi đêm đại nhạc hội kết thúc</li>
                        <li>Lightstick phát miễn phí (Số lượng có hạn).</li>
                    </ul>
                </div>
            </div>
        ),
        contentClassName: ' ',
        className: '',
    },
    {
        title: 'NỘI QUY THAM DỰ "VƯƠN CONCERT"',
        titleClassName: 'p-2 text-[24px] font-extrabold text-white',
        content: (
            <div className="text-black font-bold font-montserrat text-[12px] p-3">
                <ul className="list-decimal pl-6 space-y-1 font-bold font-montserrat text-[12px]">
                    <li>
                        Không mang đồ ăn, chai nước uống (được phép mang nước đựng trong cốc mềm, cốc giấy, túi zip),
                        các loại ghế ngồi từ ngoài vào trong khu vực tổ chức concert.
                    </li>
                    <li>
                        Không mang vũ khí, vật cháy nổ, sắc nhọn, đèn laser, đèn pin, ô dù, bút viết, gậy selfie, chân
                        máy ảnh.
                    </li>
                    <li>Không sử dụng chất cấm, vật dụng gây cháy nổ</li>
                    <li>Không mang bao thuốc lá vào sự kiện</li>
                    <li>Không mang theo động vật hoặc thú cưng</li>
                    <li>Không mang balo/túi xách có kích thước lớn hơn 26x26 cm</li>
                    <li>
                        Không mang áp phích/ bảng cổ vũ/ bảng chỉ dẫn mang tính chất chính trị, ngôn từ không phù hợp
                        thuần phong mỹ tục
                    </li>
                    <li>
                        Không chen lấn, xô đẩy trong lúc diễn ra sự kiện, không được ôm hàng rào và lắc mạnh, gây ảnh
                        hưởng an toàn.
                    </li>
                    <li>
                        Không gây gổ đánh nhau hoặc tham gia vào bất kỳ hành động nào có thể gây hại, gây nguy hiểm, đe
                        dọa hoặc mang lại sự khó chịu cho những người tham dự khác.
                    </li>
                    <li>Không sử dụng chất cấm, vật dụng gây cháy nổ</li>
                </ul>
            </div>
        ),
        contentClassName: ' ',
        className: '',
    },
];

export const SINGERS = [
    {
        id: 6,
        name: 'Thành Trung',
        //imageUrl:'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/artists/sliders/artist02.png',
        imageUrl:
            'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/artists/sliders/artist-thanh-trung.png',
        category: 'CA SĨ',
    },
    {
        id: 7,
        name: 'Hà Đức Tâm',
        //imageUrl:'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/artists/sliders/artist02.png',
        imageUrl:
            'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/artists/sliders/artist-ho-duc-tam.png',
        category: 'CA SĨ',
    },
    {
        id: 8,
        name: 'Minh Thúy',
        //imageUrl:'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/artists/sliders/artist02.png',
        imageUrl:
            'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/artists/sliders/artist-minh-thuy.png',
        category: 'CA SĨ',
    },
    {
        id: 9,
        name: 'Bé Xệ Xệ',
        //imageUrl:'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/artists/sliders/artist02.png',
        imageUrl:
            'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/artists/sliders/artist-be-xe-xe.png',
        category: 'CA SĨ',
    },
    {
        id: 1,
        name: 'Mỹ Tâm',
        //imageUrl:'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/artists/sliders/artist01.png',
        imageUrl:
            'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/artists/sliders/artist-my-tam.png',
        category: 'CA SĨ',
    },
    {
        id: 2,
        name: 'Thùy Chi',
        //imageUrl:'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/artists/sliders/artist02.png',
        imageUrl:
            'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/optimized/artist-thuy-chi.webp',
        category: 'CA SĨ',
    },
    {
        id: 3,
        name: 'Quân A.P',
        //imageUrl:'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/artists/sliders/artist01.png',
        imageUrl:
            'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/artists/sliders/artist-quan-ap.png',
        category: 'CA SĨ',
    },
    {
        id: 4,
        name: 'Anh Tú',
        //imageUrl:'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/artists/sliders/artist02.png',
        imageUrl:
            'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/artists/sliders/artist-anh-tu.png',
        category: 'CA SĨ',
    },
    {
        id: 5,
        name: 'Lamoon',
        //imageUrl:'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/artists/sliders/artist02.png',
        imageUrl:
            'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/artists/sliders/artist-lamoon.png',
        category: 'CA SĨ',
    },
];

export const HIGHLIGHT_MOMENTS = [
    'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/optimized/highlight-moment-01.webp',
    'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/optimized/highlight-moment-02.webp',
    'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/optimized/highlight-moment-03.webp',
    'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/optimized/highlight-moment-04.webp',
    'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/optimized/highlight-moment-05.webp',
];

export const ANIVERSARY_DESCRIPTION = `Trong suốt những năm qua, KidsPlaza đã vinh dự đồng hành cùng Quý khách hàng và Quý đối tác gieo những hạt mầm ý nghĩa cho hàng triệu gia đình Việt. Năm nay, bước sang mùa Festival thứ 10, chúng tôi mang đến phiên bản đặc biệt FESTIVAL TREND – "Cùng con vươn mình - Kiến tạo tương lai". Không chỉ là một sự kiện thường niên, Festival đã trở thành biểu tượng tiên phong, nơi khởi nguồn những xu hướng nuôi dạy con hiện đại, kết nối Gen Y và Gen Z – những thế hệ cha mẹ đầy khát vọng, tự tin và bản lĩnh.`;

export const PARTNERS = [
    {
        name: 'Similac',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-01.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Abbott Grow',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-02.png',
        width: 170,
        height: 70,
    },
    {
        name: 'PediaSure',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-03.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Nutifood',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-04.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Aptamil',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-05.png',
        width: 170,
        height: 70,
    },
    {
        name: 'NAN',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-06.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Forever',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-07.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Enfa',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-08.png',
        width: 170,
        height: 70,
    },
    {
        name: 'ColosBaby',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-09.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Moony',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-10.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Bobby',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-11.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Hipp',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-12.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Aveeno Baby',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-13.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Maeil',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-14.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Meiji',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-15.png',
        width: 170,
        height: 70,
    },
    {
        name: 'BioCare',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-16.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Dr.Papie',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-17.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Wakodo',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-18.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Cetaphil',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-19-v3.png',
        width: 170,
        height: 70,
    },
    {
        name: 'BZU BZU',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-20.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Purenn',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-21.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Hegen',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-22.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Lactacyd',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-23.png',
        width: 170,
        height: 70,
    },
    {
        name: 'LN',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-24.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Glico',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-25.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Molfix',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-26.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Blackmores',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-27.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Kidsmix',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-28.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Sachi',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-29.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Momimts',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-30.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Monte',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-31.png',
        width: 170,
        height: 70,
    },
    {
        name: 'VPBank Prime+',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-32.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Ich Nhi',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-33.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Lineabon',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-34.png',
        width: 170,
        height: 70,
    },
    {
        name: 'TH True Formula',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-35.png',
        width: 170,
        height: 70,
    },
    {
        name: 'TH True Food',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-36.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Hakubaku',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-37.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Hưng Chương',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-38.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Johnson’s Baby',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-39.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Kurtéskin',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-40.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Lactacyd Baby',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-41.png',
        width: 170,
        height: 70,
    },
    {
        name: 'BIDV',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-42.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Bellamy’s Organic',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-43.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Baby Steps',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-44.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Mammy',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-45.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Huggies',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-46-v2.png',
        width: 170,
        height: 70,
    },
    {
        name: 'RRO',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-47.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Altawell',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-48.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Wesser',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-49-v2.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Dayper',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-50.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Skinco',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-51.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Ova',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-52.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Top Kids',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-53.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Anpaso',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-54-v2.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Gooby',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-55.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Mamogom',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-56.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Pigeon',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-57-v2.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Sabina',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-58.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Kem Ý Gelato',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-59.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Eagle Brand',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-60.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Midu',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-61.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Hunmed',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-62.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Ferrolip Baby',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-63.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Dược phẩm Ưu Việt',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-64.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Starmed',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-65.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Fysoline',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-66.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Kendamil',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-67.png',
        width: 170,
        height: 70,
    },
    {
        name: 'VitaDairy',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-68.png',
        width: 170,
        height: 70,
    },
    {
        name: 'I-Yo-ma',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-69.png',
        width: 170,
        height: 70,
    },
    {
        name: 'HSH',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-70.jpg',
        width: 170,
        height: 70,
    },
    {
        name: 'Châu Đại Dương',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-71.jpg',
        width: 170,
        height: 70,
    },
    {
        name: '—',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-72.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Oshito',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-73-v2.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Rivsea',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-74.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Chicco',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-75.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Nutricare',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-76.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Arla',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-77.png',
        width: 170,
        height: 70,
    },
    {
        name: 'Yihetang',
        src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/p-78.png',
        width: 170,
        height: 70,
    },
];
